import { Theme } from '@mui/material/styles'

const muiDivider = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        margin: 0
      }
    }
  }
}

export default muiDivider
